// TypeScript’s type narrowing isn’t always preserved across array methods like .filter()
// can be used instead of `value !== undefined` to narrow down the type of a value
export default function notUndefined<T>(value: T | undefined): value is T {
    return value !== undefined;
}
